import React from "react";

const NextPageLoaderIcon = ({ className, width = "48", height = "48" }) => {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
          <path d="M34.601 21H46.3985C47.0344 21 47.3817 21.7416 46.9747 22.2301L41.0759 29.3086C40.7761 29.6684 40.2234 29.6684 39.9236 29.3086L34.0249 22.2301C33.6178 21.7416 33.9652 21 34.601 21Z" fill="#595252"/>
          <path d="M1.60104 27H13.3985C14.0344 27 14.3817 26.2584 13.9746 25.7699L8.07593 18.6914C7.77608 18.3316 7.22344 18.3316 6.9236 18.6914L1.02488 25.7699C0.617797 26.2584 0.965166 27 1.60104 27Z" fill="#595252"/>
          <path fillRule="evenodd" clipRule="evenodd" d="M23.9998 9C19.3423 9 15.1815 11.1209 12.4278 14.4552C11.9003 15.0939 10.9548 15.1841 10.3161 14.6566C9.67733 14.129 9.58715 13.1836 10.1147 12.5448C13.4138 8.55008 18.4096 6 23.9998 6C32.8249 6 40.1638 12.3495 41.703 20.729C41.7196 20.8191 41.7355 20.9094 41.7507 21H38.7C37.311 14.1533 31.2557 9 23.9998 9ZM9.29952 27C10.6886 33.8467 16.7439 39 23.9998 39C28.6572 39 32.8181 36.8791 35.5717 33.5448C36.0992 32.9061 37.0447 32.8159 37.6834 33.3434C38.3222 33.871 38.4124 34.8164 37.8848 35.4552C34.5857 39.4499 29.5899 42 23.9998 42C15.1747 42 7.8357 35.6505 6.29651 27.271C6.27996 27.1809 6.26408 27.0906 6.24888 27H9.29952Z" fill="#595252"/>
        </g>
      </svg>
    </div>
  );
};

export default NextPageLoaderIcon;


